package com.sweetlime.bingeamigo.model

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class LibraryTvShow(
    val id: Int,
    val tvShow: TvShow,
    val userRating: Double = 0.0,
    val userReview: String? = null,
    val tracking: Boolean = false,
    val completed: Boolean = false,
    val favorite: Boolean = false,
    val addedAt: Timestamp? = null,
    val completedAt: Timestamp? = null,
    val favoriteAt: Timestamp? = null,
    val lastMarkedAt: Timestamp? = null,
    val episodes: List<LibraryEpisode> = emptyList()
)

fun TvShow.toLibraryTvShow() = LibraryTvShow(
    id = id,
    tvShow = this
)